import 'vuetify/dist/vuetify.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import axios, { configureApiClient } from '@/utils/apiClient'
import PrettyCheckbox from 'pretty-checkbox-vue'
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from 'vuetify'

import CommonMixin from './mixins/CommonMixin.js'
Vue.mixin(CommonMixin)
import CustomsHistory from './components/artworks/CustomsHistory.vue';

Vue.component('CustomsHistory', CustomsHistory);

// Vue.use(mdi)
Vue.use(Vuetify, {
  theme: {
    primary: '#000',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})
Vue.use(Vuex)
Vue.use(require('vue-shortkey'))
Vue.use(PrettyCheckbox);

if (process.env.NODE_ENV === 'production') {
  Vue.prototype.$globals = {
    apiserver: 'https://api.tb-cms.org',
    // apiserver: 'https://tbaapi.local',
    oldserver: 'https://api.tb-cms.org',
    // fileserver: 'http://api.misia.sk'
    fileserver: 'https://api.tb-cms.org'
  }
} else {
  Vue.prototype.$globals = {
    // apiserver: 'https://api.tb-cms.org',
    apiserver: 'http://localhost:3000',
    // apiserver: 'https://tbaapi.local',
    oldserver: 'https://api.tb-cms.org',
    // fileserver: 'http://api.misia.sk'
    fileserver: 'https://api.tb-cms.org'
  }
}

configureApiClient({
  baseURL: Vue.prototype.$globals.apiserver,
  store,
  router
})
// Vue.prototype.$globals = { apiserver: 'http://api.tb-cms.org:8078' }
// } else {
//   Vue.prototype.$globals = { apiserver: 'http://192.168.0.217:3000' }
// }

export const serverBus = new Vue()

store.dispatch('initialiseStore')

// Vue.config.productionTip = false
Vue.config.performance = true

/* eslint-disable no-new */
new Vue({
  store,
  afterCreate () {
    // this.$store.dispatch('loadCollection')
    // this.$store.dispatch('loadPacFvh')
  },
  el: '#app',
  data: {
    filters: []
  },
  router,
  axios,
  render: h => h(App)
})
// if (localStorage.getItem('profile') != null) {
  // Vue.set(store.state, 'profile', JSON.parse(localStorage.getItem('profile')))
// }

// store.subscribe((mutation, state) => {
//   // Store the state object as a JSON string
//   localStorage.setItem('store', JSON.stringify(state))
//   console.log('state saved to localStorage')
// })



// WEBPACK FOOTER //
// ./src/main.js